module.exports = __webpack_public_path__ + "img/55248hlys2.e6317b49.gif";